(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["js-diesel-vehicle-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('js-diesel-finder')) return;

  class DieselFinder extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.form = this.querySelector('form');
      this.fields = [...this.querySelectorAll('select[data-key]')];
      this.primaryFields = this.fields.slice(0, 4);
      this.typeField = this.fields[4];
      this.typeRow = this.querySelector('.jsdf__type-row');
      this.submit = this.querySelector('.jsdf__submit');
      this.status = this.querySelector('.jsdf__status');
      this.retry = this.querySelector('.jsdf__retry');
      this.cache = new Map();
      this.sequence = 0;
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.fields.forEach((field, index) => field.addEventListener('change', () => {
        this.fields.slice(index + 1).forEach(next => this.empty(next));
        this.typeRow.hidden = true;
        this.refresh();
      }, options));
      this.querySelector('.jsdf__reset').addEventListener('click', () => {
        this.fields.forEach(field => this.empty(field));
        this.typeRow.hidden = true;
        this.refresh();
      }, options);
      this.retry.addEventListener('click', () => this.refresh(), options);
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (this.submit.disabled || !this.form.reportValidity()) return;
        window.location.assign(this.buildUrl().toString());
      }, options);
      this.initialize();
    }

    disconnectedCallback() {
      this.sequence++;
      this.controller?.abort();
      this.listeners?.abort();
      this.started = false;
    }

    empty(field) {
      const label = { make: 'Select make', year: 'All years', model: 'All models', engine: 'All engine sizes', type: 'Any / not sure' }[field.dataset.key];
      field.replaceChildren(new Option(label, ''));
      field.disabled = true;
    }

    message(text, error = false) {
      this.status.textContent = text;
      this.status.toggleAttribute('data-error', error);
    }

    buildUrl(values = null) {
      if (!this.dataset.collectionUrl || !this.dataset.collectionHandle) throw new Error('Missing collection');
      const url = new URL(this.dataset.collectionUrl, document.baseURI);
      if (/^https?:$/.test(location.protocol) && url.origin !== location.origin) throw new Error('Invalid collection origin');
      url.search = '';
      url.hash = '';
      // Preserve unpublished theme preview context, never unrelated product filters.
      const current = new URL(location.href);
      const preview = current.searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      this.fields.forEach(field => {
        const value = values ? values[field.name] : field.value;
        if (value) url.searchParams.set(field.name, value);
      });
      return url;
    }

    async request(values, signal) {
      const url = this.buildUrl(values);
      url.searchParams.set('section_id', 'js-diesel-finder-data');
      const key = url.toString();
      if (this.cache.has(key)) return this.cache.get(key);
      const response = await fetch(key, { signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Unable to read collection');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const payload = doc.querySelector('[data-jsdf-payload]');
      if (!payload) throw new Error('Missing data section');
      const data = JSON.parse(payload.textContent);
      if (data.collection !== this.dataset.collectionHandle || !Array.isArray(data.filters) || !Number.isInteger(data.count) || data.count < 0) throw new Error('Invalid collection response');
      if (this.cache.size >= 24) this.cache.delete(this.cache.keys().next().value);
      this.cache.set(key, data);
      return data;
    }

    valuesFor(data, field) {
      const facet = data.filters.find(filter => filter.name === field.name);
      if (!facet || !Array.isArray(facet.values)) return [];
      return facet.values.filter(item => item.count > 0 && item.value &&
        (field.dataset.key !== 'type' || !/^\d+$/.test(String(item.value))))
        .sort((a, b) => field.dataset.key === 'year'
          ? parseFloat(b.value) - parseFloat(a.value)
          : String(a.label).localeCompare(String(b.label), undefined, { numeric: true }));
    }

    populate(field, data) {
      const choices = this.valuesFor(data, field);
      this.empty(field);
      choices.forEach(item => {
        const label = field.dataset.key === 'make' && item.value === 'GM' ? 'Chevrolet / GMC' : item.label;
        field.add(new Option(label, item.value));
      });
      field.disabled = choices.length === 0;
      return choices.length;
    }

    async initialize() {
      // A results-page URL is the source of truth. Revalidate restored selections
      // in order, rather than carrying old choices across vehicles or collections.
      const current = new URL(location.href);
      const restored = this.fields.map(field => current.searchParams.get(field.name) || '');
      if (!await this.refresh()) return;
      for (let i = 0; i < this.fields.length; i++) {
        const field = this.fields[i];
        if (!restored[i] || field.disabled || ![...field.options].some(option => option.value === restored[i])) break;
        field.value = restored[i];
        if (!await this.refresh()) break;
      }
    }

    async refresh() {
      const requestId = ++this.sequence;
      this.controller?.abort();
      this.controller = new AbortController();
      this.submit.disabled = true;
      this.retry.hidden = true;
      this.form.setAttribute('aria-busy', 'true');
      const selected = Object.fromEntries(this.fields.map(field => [field.name, field.value]));
      // Keep completed steps editable so a slow request never traps the visitor.
      this.fields.forEach(field => { field.disabled = !field.value; });
      this.message('Loading vehicle options…');
      let timedOut = false;
      const controller = this.controller;
      const timer = setTimeout(() => { timedOut = true; controller.abort(); }, 12000);
      try {
        const data = await this.request(selected, controller.signal);
        if (requestId !== this.sequence || !this.isConnected) return false;
        const canSearch = Boolean(this.fields[0].value) && data.count > 0;
        const matches = data.count + (data.count === 1 ? ' product matches' : ' products match') + ' these filters.';
        const next = this.primaryFields.find(field => !field.value);
        if (next) {
          const found = this.populate(next, data);
          // Make is enough to browse. Later selections only narrow the results.
          // Missing downstream metadata must not block a broader search.
          this.submit.disabled = !canSearch;
          if (next.dataset.key === 'make') {
            this.message(found
              ? 'Choose your make to search. Add more vehicle details if you want to narrow the results.'
              : 'No makes are listed. Browse diesel parts below or call us for help.', !found);
          } else if (canSearch) {
            const detail = next.dataset.key === 'engine' ? 'engine size' : next.dataset.key;
            this.message(matches + (found
              ? ' Search now, or add your ' + detail + ' to narrow the results.'
              : ' Search now with the details selected.'));
          } else {
            this.message('No products match these filters. Change your selection or call us for help.', true);
          }
          return true;
        }
        if (this.dataset.engineType === 'true') {
          let typeData = data;
          if (this.typeField.value) {
            // Exclude this facet while loading its alternatives; otherwise its
            // own AND filter could hide valid choices or the clear option.
            const withoutType = { ...selected, [this.typeField.name]: '' };
            typeData = await this.request(withoutType, controller.signal);
            if (requestId !== this.sequence || !this.isConnected) return false;
          }
          const previousType = this.typeField.value;
          const choices = this.populate(this.typeField, typeData);
          this.typeRow.hidden = choices < 2 && !previousType;
          if (previousType && [...this.typeField.options].some(option => option.value === previousType)) this.typeField.value = previousType;
          if (this.typeRow.hidden) this.typeField.disabled = true;
        }
        this.submit.disabled = !canSearch;
        this.message(data.count > 0
          ? matches + ' Check individual fitment before ordering.'
          : 'No products match these filters. Change your selection or call us for help.', data.count === 0);
        return true;
      } catch (error) {
        if (requestId !== this.sequence || !this.isConnected) return false;
        if (error.name === 'AbortError' && !timedOut) return false;
        this.retry.hidden = false;
        this.message('The finder couldn’t load. Try again, browse diesel parts below, or call us.', true);
        return false;
      } finally {
        clearTimeout(timer);
        if (requestId === this.sequence) this.form.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('js-diesel-finder', DieselFinder);
})();

  } catch(e) { console.error(e); }
})();
})();
